/**
 * Convert any FastAPI/Axios error into a safe, displayable string.
 * Handles Pydantic v2 validation errors (array of {type, loc, msg, ...}).
 */
export function formatApiError(err, fallback = 'Ein Fehler ist aufgetreten') {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail.map((d) => {
      if (!d || typeof d !== 'object') return String(d);
      const loc = Array.isArray(d.loc)
        ? d.loc.filter((x) => x !== 'body' && x !== 'query').join('.')
        : '';
      const msg = d.msg || '';
      if (loc && msg) return `${loc}: ${msg}`;
      return msg || JSON.stringify(d);
    }).filter(Boolean);
    if (parts.length) return parts.join('; ');
  }
  if (detail && typeof detail === 'object') return JSON.stringify(detail);
  if (status === 429) return 'Zu viele Versuche. Bitte kurz warten und erneut senden.';
  if (status >= 500) {
    return 'Der Server konnte die Anmeldung gerade nicht speichern. Bitte in einer Minute erneut versuchen.';
  }
  if (!err?.response) return 'Keine Verbindung zum Server. Bitte erneut versuchen.';
  return fallback;
}
